export { FAQs } from "./FAQs";